import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-6 gap-6" }
const _hoisted_2 = { class: "col-span-6" }
const _hoisted_3 = { class: "grid grid-cols-6 gap-6" }
const _hoisted_4 = { class: "md:col-span-3 col-span-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-3 md:block hidden" }, null, -1)
const _hoisted_6 = { class: "md:col-span-3 col-span-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-3 md:block hidden" }, null, -1)
const _hoisted_8 = { class: "md:col-span-3 col-span-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-3 md:block hidden" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "md:col-span-3 col-span-6 border-t border-gray-200" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-3 md:block hidden" }, null, -1)
const _hoisted_12 = { class: "md:col-span-3 col-span-6" }
const _hoisted_13 = { class: "flex items-center justify-end w-full space-x-3" }
const _hoisted_14 = { href: "/personnel/index/" }

import { ref } from 'vue';
import { numberonly } from "@/components/composables/useNumberOnly";
import TextInput from '@/components/inputs/TextInput.vue';
import PasswordInput from '@/components/inputs/PasswordInput.vue';
import ButtonComponent from '@/components/buttons/ButtonComponent.vue';

import ConfirmationModal from '@/components/modals/ConfirmationModal.vue';
import SuccessModal from '@/components/modals/SuccessModal.vue';
import GeneralModal from '@/components/modals/GeneralModal.vue';

import Profile from "@/classes/Profile";
import { errorResponse } from "@/helpers/errorMessage";

import PageLoader from "@/components/loaders/PageLoader.vue"

import PinCodeProcessor from '@/helpers/hashPin'

import Storage from "@/helpers/storage";

import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'FormSection',
  setup(__props) {

const router = useRouter();

const storage = new Storage();

const showConfirmation = ref<boolean>(false);
const showSuccess = ref<boolean>(false);

const showForgotPin = ref<boolean>(false);
const showForgotPinSuccess = ref<boolean>(false);

const loading = ref<boolean>(false);

const errors = ref<any>();
const current_password = ref<string | null>(null);

const user = JSON.parse(storage.get('user'));

const form = ref<{
    current_pin_code: string | null;
    new_pin_code: string | null;
    new_pin_code_confirmation: string | null;
}>({
    current_pin_code: null,
    new_pin_code: null,
    new_pin_code_confirmation: null,
});


const validatePin = (): void => {
    if (PinCodeProcessor.validate(form.value.current_pin_code)) {
        showConfirmation.value = true
    } else {
        errors.value = { 'current_pin_code': 'Pin code does not match' };
    }
}

const validatePassword = (process: string): void => {
    loading.value = true
    Profile.validatePassword(current_password.value)
        .then(() => {
            loading.value = false
            showForgotPin.value = false
            showConfirmation.value = false

            if (process == 'update'){
                validate();
            } else if (process == 'forgot_pin') { 
                resetPin()
            }
        })
        .catch((error: any) => {
            loading.value = false
            
            errors.value = errorResponse(error.response?.data?.errors)
        })
}

const reload = (): void => {
    location.reload()
}

const validate = (): void => {
    showConfirmation.value = false
    if (form.value.new_pin_code != form.value.new_pin_code_confirmation) {
        errors.value = {
            new_pin_code: "New pin code did not match",
            new_pin_code_confirmation: "New pin code did not match"
        }
    } else if (form.value.new_pin_code.length != 6) {
        errors.value = {
            new_pin_code: "New pin code must be 6 digits",
            new_pin_code_confirmation: "New pin code must be 6 digits"
        }
    } else {
        submit()
    }
}

const submit = (): void => {
    showConfirmation.value = false
    loading.value = true

     PinCodeProcessor.setPin(form.value.new_pin_code).then(() => {
        showSuccess.value = true;
        loading.value = false;
    })
    .catch((error: any) => {
        loading.value = false;

        errors.value = errorResponse(error.response?.data?.errors)
    })
}

const resetPin = (): void => {
    user.pin_code = null;

    storage.set('user', JSON.stringify(user));

    loading.value = true;
    router.go(0);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(PasswordInput, {
            label: "Current PIN",
            placeholder: "Current PIN",
            name: "current-pin",
            id: "current-pin",
            modelValue: form.value.current_pin_code,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.current_pin_code) = $event)),
            error: errors.value?.current_pin_code,
            maxlength: 6,
            onKeypress: _unref(numberonly)
          }, null, 8, ["modelValue", "error", "onKeypress"])
        ]),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(PasswordInput, {
            label: "New PIN",
            placeholder: "New PIN",
            name: "new-pin",
            id: "new-pin",
            modelValue: form.value.new_pin_code,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.new_pin_code) = $event)),
            error: errors.value?.new_pin_code,
            maxlength: 6,
            onKeypress: _unref(numberonly)
          }, null, 8, ["modelValue", "error", "onKeypress"])
        ]),
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createVNode(PasswordInput, {
            label: "Retype New PIN",
            placeholder: "Retype New PIN",
            name: "confirm-pin",
            id: "confirm-pin",
            modelValue: form.value.new_pin_code_confirmation,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.new_pin_code_confirmation) = $event)),
            error: errors.value?.new_pin_code_confirmation,
            maxlength: 6,
            onKeypress: _unref(numberonly)
          }, null, 8, ["modelValue", "error", "onKeypress"]),
          _createElementVNode("a", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (showForgotPin.value=true)),
            class: "inline-block mt-3 text-xs transition text-primary-600 hover:text-primary-800"
          }, " Forgotten your PIN? ")
        ]),
        _hoisted_9,
        _hoisted_10,
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("a", _hoisted_14, [
              _createVNode(ButtonComponent, { btnWidth: "quinary" }, {
                default: _withCtx(() => [
                  _createTextVNode("Cancel")
                ]),
                _: 1
              })
            ]),
            _createVNode(ButtonComponent, {
              btnWidth: "primary",
              onClick: validatePin
            }, {
              default: _withCtx(() => [
                _createTextVNode("Save Changes")
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createVNode(ConfirmationModal, {
      typeTwo: true,
      show: showConfirmation.value,
      onCancel: _cache[5] || (_cache[5] = ($event: any) => (showConfirmation.value = false)),
      onConfirm: _cache[6] || (_cache[6] = ($event: any) => {validatePassword('update');}),
      "cancel-text": "Cancel",
      "action-text": "Proceed",
      title: "Confirmation",
      content: "Are you sure you wish to change your pin?"
    }, {
      fields: _withCtx(() => [
        _createVNode(PasswordInput, {
          placeholder: "Current Password",
          name: "current-password",
          id: "current-password",
          modelValue: current_password.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((current_password).value = $event)),
          error: errors.value?.current_password
        }, null, 8, ["modelValue", "error"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(SuccessModal, {
      show: showSuccess.value,
      onConfirm: reload,
      "action-text": "Close",
      title: "Success!",
      content: "Your pin has been successfully changed"
    }, null, 8, ["show"]),
    _createVNode(ConfirmationModal, {
      typeTwo: true,
      show: showForgotPin.value,
      onCancel: _cache[8] || (_cache[8] = ($event: any) => (showForgotPin.value = false)),
      onConfirm: _cache[9] || (_cache[9] = ($event: any) => {validatePassword('forgot_pin');}),
      "cancel-text": "Cancel",
      "action-text": "Proceed",
      title: "Forgot your pin?",
      content: "Please enter your password to continue."
    }, {
      fields: _withCtx(() => [
        _createVNode(PasswordInput, {
          placeholder: "Current Password",
          name: "current-password",
          id: "current-password",
          modelValue: current_password.value,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((current_password).value = $event)),
          error: errors.value?.current_password
        }, null, 8, ["modelValue", "error"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"])
  ]))
}
}

})